import { Form } from 'react-router';
import { AuthenticityTokenInput } from 'remix-utils/csrf/react';

import { type PropsWithClassName } from '~/utils/props-with-classname';

import { type ButtonProps } from '../ui/button';

import { FavoriteButton } from './favorite-button';

interface Props {
  gymSlug: string;
  isFavorite: boolean;
  returnRoute: string;
  size?: ButtonProps['size'];
}

export function GymFavoriteForm({
  gymSlug,
  isFavorite,
  returnRoute,
  size,
  className,
}: PropsWithClassName<Props>) {
  return (
    <Form
      action={`/gym/${gymSlug}/set-favorite`}
      method="post"
      className={className}
      preventScrollReset={true}
    >
      <AuthenticityTokenInput />
      <input type="hidden" name="isFavorite" value={(!isFavorite).toString()} />
      <input type="hidden" name="returnRoute" value={returnRoute} />
      <FavoriteButton type="submit" highlighted={isFavorite} size={size} />
    </Form>
  );
}
